import { Box, useMediaQuery, useTheme } from "@mui/material";
import ContractorCard from "../../permitComponents/ContractorCard";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

const QuickActionContractorCard = () => {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const currentUser = useSelector((state) => state[currentSession].user);

  const [currentContractor, setCurrentContractor] = useState({});
  const [cardPage, setCardPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);

  const handleNavigate = (direction) => {
    let newPage;
    if (direction === "forward") {
      newPage = cardPage + 1;
    } else if (direction === "back") {
      if (cardPage === 1) {
        return;
      }
      newPage = cardPage - 1;
    }

    setCurrentContractor(currentUser?.user?.contractors?.[newPage - 1]);
    setCardPage(newPage);
  };

  useEffect(() => {
    if (currentUser?.user?.contractors) {
      if (currentUser?.user?.contractors.length > 0) {
        const firstContractor = currentUser?.user?.contractors[0];

        setCurrentContractor(firstContractor);

        setMaxPage(currentUser?.user?.contractors.length);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser?.user?.contractors]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const hasContractor = Object?.keys(currentContractor).length > 0;

  return (
    <Box
      sx={{
        position: "relative",
        mt: isMobile ? 0 : hasContractor ? -10 : -3,
      }}
    >
      <ContractorCard
        data={
          Object?.keys(currentContractor).length > 0 ? currentContractor : null
        }
        // mb={0}
        colorIndex={cardPage}
        empty={currentUser?.user?.contractors.length === 0}
        showLicenseInput={false}
        contractorSite={true}
        handleEditContractor={() => {}}
        addNewActive={false}
        currentContractor={currentContractor}
        fromQuickActions={true}
        handleNavigate={handleNavigate}
        maxPage={maxPage}
        cardPage={cardPage}
      />
    </Box>
  );
};

export default QuickActionContractorCard;
